import React, {
  useState,
  Fragment,
  useCallback,
  Suspense,
  useEffect,
} from "react";
import { Card, CardBody, CardHeader, Form, FormGroup, Input } from "reactstrap";
import { Breadcrumbs, Btn, H4 } from "../../../AbstractElements";
import Loader from "../../../Layout/Loader";
import DataTable from "react-data-table-component";
import { pharmacytabledata, tableColumns } from "../../../Data/Pharmacy";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { DeletePharmacy, PharmacyList } from "../../../apiController";
import { Navigator } from "../../../Data/Table/Defaultdata";
import { roles_permissions } from "../../../Layout/Sidebar/Menu";
const PharmacyIndex = () => {
  const navigate = useNavigate();

  const permission = roles_permissions.find(
    (module) => module.module_name === "Pharmacy"
  );

  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
    // searchMember(keyword);
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [data, setData] = useState();
  const [pharmacy, setPharmacy] = useState([]);

  const clearSearchTab = () => {
    setSearchKeyword("");
  };
  const searchedPharmacy = pharmacy.filter(
    (c) =>
      (c.available_stock?.toLowerCase() ?? "").includes(
        searchKeyword.toLowerCase()
      ) ||
      (c.price?.toLowerCase() ?? "").includes(searchKeyword.toLowerCase()) ||
      (c.sub_name?.toLowerCase() ?? "").includes(searchKeyword.toLowerCase()) ||
      (c.category_name?.toLowerCase() ?? "").includes(
        searchKeyword.toLowerCase()
      ) ||
      (`${c.first_name} ${c.surname}`.toLowerCase() ?? "").includes(
        searchKeyword.toLowerCase()
      ) ||
      (c.phone ?? "").includes(searchKeyword.toLowerCase()) ||
      c.gender?.toLowerCase() === searchKeyword.toLowerCase() ||
      (c.patient_reg_no ?? "").includes(searchKeyword.toLowerCase())
  );

  const pharmacytabledata = searchedPharmacy.map((row, ind) => ({
    ind: ind + 1,
    id: row.id,
    category: row.category_name,
    medicinename: row.sub_name,
    price: row.price,
    stockavailable: row.available_stock,
    action: (
      <span>
        {
          <Navigator
            to={`${process.env.PUBLIC_URL}/pharmacyform/:layout`}
            params={{ rowData: row, btn: "edit" }}
          />
        }
      </span>
    ),
  }));

  const tableColumns = [
    {
      name: "#",
      selector: (row) => row["id"],
      sortable: true,
      center: false,
    },
    {
      name: "Category",
      selector: (row) => row["category"],
      sortable: true,
      center: false,
    },
    {
      name: "Medicine Name",
      selector: (row) => row["medicinename"],
      sortable: true,
      center: true,
    },
    {
      name: "Price",
      selector: (row) => `${row.price}`,
      sortable: true,
      center: true,
    },
    {
      name: "Stock Available",
      selector: (row) => `${row.stockavailable}`,
      sortable: true,
      center: true,
    },
    // {
    //     name: 'Action',
    //     selector: row => row['action'],
    //     sortable: false,
    //     center: true,
    // },
  ];

  if (permission?.edit_access) {
    tableColumns.push({
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    });
  }

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure you want to delete?",
      cancelButtonText: "No!",
      confirmButtonText: "Yes!",
      reverseButtons: true,
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map((row) => row.id);
        await Promise.all(selectedIds.map((id) => DeletePharmacy(id)));
        setSelectedRows([]);
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchPharmacy();
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const fetchPharmacy = async () => {
    const response = await PharmacyList();
    if (response.status === true) {
      setPharmacy(response.data);
    }
  };

  useEffect(() => {
    fetchPharmacy();
  }, []);
  return (
    <Suspense fallback={<Loader />}>
      <Card>
        <Breadcrumbs mainTitle="Pharmacy" parent="Dashboard" title="pharmacy" />
        <CardHeader className="card-no-border">
          <div className="header-top">
            <Fragment>
              <div className="search">
                <Form className="theme-form">
                  <FormGroup className="form-group">
                    <div className="input-group">
                      <Input
                        className="form-control"
                        type="text"
                        placeholder="search"
                        value={searchKeyword}
                        onChange={(e) => handleSearchKeyword(e.target.value)}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          onClick={() => clearSearchTab()}
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </Fragment>
          {permission?.create_access &&    <div className="card-header-right-icon">
              <div className="card-header-right-icon">
                <Btn
                  attrBtn={{
                    color: "light-primary",
                    className: "btn badge-light-primary",
                    onClick: () => {
                      navigate(
                        `${process.env.PUBLIC_URL}/pharmacyform/:layout`,
                        { state: "" }
                      );
                    },
                  }}
                >
                  + Add Pharmacy
                </Btn>
              </div>
            </div>}
          </div>
        </CardHeader>
        <CardBody className="pt-0 campaign-table">
          <div className="recent-table table-responsive currency-table">
            <Fragment>
              {selectedRows.length !== 0 && (
                <div
                  className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
                >
                  <H4 attrH4={{ className: "text-muted m-0" }}>
                    Delet Selected Data..!
                  </H4>
                  <Btn
                    attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                  >
                    Delete
                  </Btn>
                </div>
              )}
              <DataTable
                data={pharmacytabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows={permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
              />
            </Fragment>
          </div>
        </CardBody>
      </Card>
    </Suspense>
  );
};

export default PharmacyIndex;
